import { useAuth } from '../contexts/auth';
import { UserRoleEnum } from '../types/user.types';

export const useIsUserRole = (role: UserRoleEnum) => {
  const { currentUser } = useAuth();

  return Boolean(currentUser?.role && role.includes(currentUser.role));
};
